module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tablePagination && _vm.tablePagination.last_page > 1) ? _c('div', {
    class: _vm.css.wrapperClass
  }, [_c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        _vm.loadPage(1)
      }
    }
  }, [(_vm.css.icons.first != '') ? _c('i', {
    class: [_vm.css.icons.first]
  }) : _c('span', [_vm._v("«")])]), _vm._v(" "), _c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        _vm.loadPage('prev')
      }
    }
  }, [(_vm.css.icons.next != '') ? _c('i', {
    class: [_vm.css.icons.prev]
  }) : _c('span', [_vm._v(" ‹")])]), _vm._v(" "), (_vm.notEnoughPages) ? [_vm._l((_vm.totalPage), function(n) {
    return [_c('a', {
      class: [_vm.css.pageClass, _vm.isCurrentPage(n) ? _vm.css.activeClass : ''],
      domProps: {
        "innerHTML": _vm._s(n)
      },
      on: {
        "click": function($event) {
          _vm.loadPage(n)
        }
      }
    })]
  })] : [_vm._l((_vm.windowSize), function(n) {
    return [_c('a', {
      class: [_vm.css.pageClass, _vm.isCurrentPage(_vm.windowStart + n - 1) ? _vm.css.activeClass : ''],
      domProps: {
        "innerHTML": _vm._s(_vm.windowStart + n - 1)
      },
      on: {
        "click": function($event) {
          _vm.loadPage(_vm.windowStart + n - 1)
        }
      }
    })]
  })], _vm._v(" "), _c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        _vm.loadPage('next')
      }
    }
  }, [(_vm.css.icons.next != '') ? _c('i', {
    class: [_vm.css.icons.next]
  }) : _c('span', [_vm._v("› ")])]), _vm._v(" "), _c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        _vm.loadPage(_vm.totalPage)
      }
    }
  }, [(_vm.css.icons.last != '') ? _c('i', {
    class: [_vm.css.icons.last]
  }) : _c('span', [_vm._v("»")])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-744da87f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vuetable-2/src/components/VuetablePagination.vue
// module id = 489
// module chunks = 1